<template>
  <div class="status-card" :class="`${type} status-card-${size} ${truncate ? 'truncate' : ''}`" v-b-tooltip.hover :title="label">
    <span class="status-card-text">{{label}}</span>
  </div>
</template>
<script>

/*
Documentation:

  - label: string variable responsible for card text;
  - type: string variable responsible for card type:
    + primary;
    + secondary;
    + success;
    + warning;
    + danger;
    + disable;
  - size: string variable responsible for the size of the card:
    + max;
    + mid;
    + min;
*/

export default {
  props: {
    label: { type: String },
    type: { type: String },
    size: { type: String },
    truncate: { type: Boolean }
  }
}
</script>
<style lang="scss" scoped>
.status-card {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  &.status-card-max {
    padding: 0 16px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
    border-radius: 5px;
  }
  &.status-card-mid {
    padding: 0 16px;
    font-size: 10px;
    line-height: 18px;
    font-weight: 600;
    border-radius: 5px;
  }
  &.status-card-min {
    padding: 0 4px;
    font-size: 8px;
    line-height: 18px;
    font-weight: 400;
    border-radius: 2.5px;
  }
  &.primary {
    background-color: lighten(#1c56e0, 35%);
    .status-card-text {
      color: #1c56e0;
    }
  }
  &.secondary {
    background-color: lighten(#4285f4, 35%);
    .status-card-text {
      color: #4285f4;
    }
  }
  &.success {
    background-color: lighten(#41bd64, 35%);
    .status-card-text {
      color: #41bd64;
    }
  }
  &.warning {
    background-color: lighten(#f09b1b, 35%);
    .status-card-text {
      color: #f09b1b;
    }
  }
  &.danger {
    background-color: lighten(#ba2129, 35%);
    .status-card-text {
      color: #ba2129;
    }
  }
  &.disable {
    background-color: #f1f1f1;
    .status-card-text {
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/order/components/StatusCard.vue